module.exports = __webpack_public_path__ + "img/ketchup.eb85a411.svg";